import { create } from 'zustand';

export const useAppStore = create((set, get) => ({
  // Auth
  user: null,
  token: localStorage.getItem('axisvms_token'),
  setAuth: (user, token) => {
    localStorage.setItem('axisvms_token', token);
    set({ user, token });
  },
  setUser: (user) => set({ user }),
  logout: () => {
    localStorage.removeItem('axisvms_token');
    set({ user: null, token: null, cameras: [], selectedCamera: null });
  },

  // Cameras
  cameras: [],
  selectedCamera: null,
  setCameras: (cameras) => set({ cameras }),
  setSelectedCamera: (camera) => set({ selectedCamera: camera }),
  updateCamera: (updated) => set(state => ({
    cameras: state.cameras.map(c => c.id === updated.id ? updated : c),
    selectedCamera: state.selectedCamera?.id === updated.id ? updated : state.selectedCamera,
  })),
  addCamera: (camera) => set(state => ({ cameras: [...state.cameras, camera] })),
  removeCamera: (id) => set(state => ({
    cameras: state.cameras.filter(c => c.id !== id),
    selectedCamera: state.selectedCamera?.id === id ? null : state.selectedCamera,
  })),

  // Groups
  groups: [],
  setGroups: (groups) => set({ groups }),

  // UI state
  activeView: 'list', // list | map | grid
  setActiveView: (view) => set({ activeView: view }),
  sidebarOpen: true,
  setSidebarOpen: (open) => set({ sidebarOpen: open }),
  activePanel: 'cameras', // cameras | audit | events | settings | notifications
  setActivePanel: (panel) => set({ activePanel: panel }),

  // Notification center: unread-since-last-opened badge count
  unreadNotifications: 0,
  setUnreadNotifications: (count) => set({ unreadNotifications: count }),
  searchQuery: '',
  setSearchQuery: (q) => set({ searchQuery: q }),
  filterGroup: null,
  setFilterGroup: (id) => set({ filterGroup: id }),
  filterStatus: null,
  setFilterStatus: (s) => set({ filterStatus: s }),

  // Toasts
  toasts: [],
  addToast: (toast) => {
    const id = Date.now() + Math.random();
    set(state => ({ toasts: [...state.toasts, { id, ...toast }] }));
    // Errors and warnings persist until dismissed; success/info auto-dismiss after 5s
    if (!toast.type || toast.type === 'success' || toast.type === 'info') {
      setTimeout(() => set(state => ({ toasts: state.toasts.filter(t => t.id !== id) })), 5000);
    }
  },
  removeToast: (id) => set(state => ({ toasts: state.toasts.filter(t => t.id !== id) })),

  // Active streams
  activeStreams: new Set(),
  addActiveStream: (id) => set(state => ({ activeStreams: new Set([...state.activeStreams, id]) })),
  removeActiveStream: (id) => set(state => {
    const s = new Set(state.activeStreams);
    s.delete(id);
    return { activeStreams: s };
  }),
}));
